(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["subscribe-flow"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    function initSection(sectionId) {
      const root = document.querySelector('[data-section-id="' + sectionId + '"]');
      if (!root || root.dataset.sfBound === 'true') return;
      root.dataset.sfBound = 'true';

      const defaultCtaLabel = root.dataset.ctaLabel || 'Continue to checkout';
      const steps = root.querySelectorAll('[data-step]');
      const stepperItems = root.querySelectorAll('[data-sf-step-item]');
      const form = root.querySelector('[data-sf-form]');
      const checkoutBtn = root.querySelector('[data-sf-checkout]');
      const backBtn = root.querySelector('[data-sf-back]');
      const globalError = root.querySelector('[data-sf-global-error]');
      const picker = root.querySelector('[data-sf-picker]');
      const choiceInputs = root.querySelectorAll('[data-sf-choice]');
      const variantsScript = root.querySelector('[data-sf-variants]');
      const summaryCard = root.querySelector('[data-sf-summary-card]');
      const summaryText = root.querySelector('[data-sf-summary-text]');
      const summaryPriceEl = root.querySelector('[data-sf-summary-price]');
      const consentInput = root.querySelector('[data-sf-consent]');
      const consentWrap = root.querySelector('[data-sf-consent-wrap]');
      const consentError = root.querySelector('[data-sf-consent-error]');
      const consentStatement = root.dataset.consentText || '';
      const consentErrorMsg = root.dataset.consentError || 'Please confirm to continue.';
      let variants = [];
      try { variants = variantsScript ? JSON.parse(variantsScript.textContent) : []; }
      catch (_) { variants = []; }
      const totalOptionGroups = picker ? picker.querySelectorAll('.sf-option-group').length : 0;
      const summaryEmptyText = picker ? picker.dataset.summaryEmpty : '';
      const summaryUnavailableText = picker ? picker.dataset.summaryUnavailable : 'This combination is unavailable';

      const state = {
        currentStep: 1,
        name: '', email: '', phone: '', age: '', country: '',
        variantId: null, sellingPlanId: null, optionTitle: null
      };

      function setStepperStatus(stepNum) {
        stepperItems.forEach(item => {
          const itemStep = Number(item.dataset.sfStepItem);
          if (itemStep < stepNum) item.setAttribute('data-status', 'done');
          else if (itemStep === stepNum) item.setAttribute('data-status', 'current');
          else item.removeAttribute('data-status');
        });
      }

      function goTo(n) {
        state.currentStep = n;
        steps.forEach(s => {
          s.setAttribute('data-active', s.dataset.step === String(n) ? 'true' : 'false');
        });
        setStepperStatus(n);
        try { root.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (_) {}
      }

      function setError(input, msg) {
        input.setAttribute('aria-invalid', 'true');
        const err = root.querySelector('[data-sf-error="' + input.dataset.sfInput + '"]');
        if (err) err.textContent = msg;
      }
      function clearError(input) {
        input.removeAttribute('aria-invalid');
        const err = root.querySelector('[data-sf-error="' + input.dataset.sfInput + '"]');
        if (err) err.textContent = '';
      }

      function validateField(input) {
        const value = input.value.trim();
        const type = input.dataset.sfInput;
        if (!value) { setError(input, 'This field is required.'); return false; }
        if (type === 'email') {
          const emailRe = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          if (!emailRe.test(value)) { setError(input, 'Please enter a valid email address.'); return false; }
        }
        if (type === 'phone') {
          const digits = value.replace(/\D/g, '');
          if (digits.length < 7) { setError(input, 'Please enter a valid phone number.'); return false; }
        }
        if (type === 'age') {
          const age = Number(value);
          if (!Number.isFinite(age) || age < 1 || age > 120) {
            setError(input, 'Please enter a valid age.'); return false;
          }
        }
        clearError(input);
        return true;
      }

      function validateStep1() {
        const inputs = form.querySelectorAll('[data-sf-input]');
        let firstInvalid = null;
        let ok = true;
        inputs.forEach(input => {
          if (!validateField(input)) {
            ok = false;
            if (!firstInvalid) firstInvalid = input;
          }
        });
        if (ok) {
          state.name = form.querySelector('[data-sf-input="name"]').value.trim();
          state.email = form.querySelector('[data-sf-input="email"]').value.trim();
          state.phone = form.querySelector('[data-sf-input="phone"]').value.trim();
          state.age = form.querySelector('[data-sf-input="age"]').value.trim();
          state.country = form.querySelector('[data-sf-input="country"]').value.trim();
        } else if (firstInvalid) {
          firstInvalid.focus();
        }
        return ok;
      }

      if (form) {
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          if (validateStep1()) goTo(2);
        });
        form.querySelectorAll('[data-sf-input]').forEach(input => {
          input.addEventListener('blur', function () {
            if (input.value.trim()) validateField(input);
          });
          input.addEventListener('input', function () {
            if (input.getAttribute('aria-invalid') === 'true') clearError(input);
          });
        });
      }

      function getSelectedOptions() {
        const sel = {};
        choiceInputs.forEach(input => {
          if (input.checked) sel[input.dataset.optionPosition] = input.dataset.optionValue;
        });
        return sel;
      }

      function variantMatches(variant, sel) {
        if (sel[1] !== undefined && variant.option1 !== sel[1]) return false;
        if (sel[2] !== undefined && variant.option2 !== sel[2]) return false;
        if (sel[3] !== undefined && variant.option3 !== sel[3]) return false;
        return true;
      }

      function formatMoney(cents, currencyCode) {
        if (typeof cents !== 'number') return '';
        if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
          try { return window.Shopify.formatMoney(cents); } catch (_) {}
        }
        const code = currencyCode || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
        try {
          return new Intl.NumberFormat(undefined, { style: 'currency', currency: code }).format(cents / 100);
        } catch (_) {
          return (cents / 100).toFixed(2);
        }
      }

      function updateChoiceAvailability(sel) {
        choiceInputs.forEach(input => {
          if (input.checked) {
            const choice = input.closest('.sf-choice');
            if (choice) choice.removeAttribute('data-disabled');
            input.disabled = false;
            return;
          }
          const trial = Object.assign({}, sel, {
            [input.dataset.optionPosition]: input.dataset.optionValue
          });
          const anyAvailable = variants.some(v => variantMatches(v, trial) && v.available !== false);
          const choice = input.closest('.sf-choice');
          if (!anyAvailable) {
            if (choice) choice.setAttribute('data-disabled', 'true');
            input.disabled = true;
          } else {
            if (choice) choice.removeAttribute('data-disabled');
            input.disabled = false;
          }
        });
      }

      function consentOk() {
        return !consentInput || consentInput.checked;
      }

      function refreshCheckoutEnabled() {
        if (!checkoutBtn) return;
        checkoutBtn.disabled = !state.variantId || !consentOk();
      }

      function clearConsentError() {
        if (consentError) consentError.textContent = '';
        if (consentWrap) consentWrap.removeAttribute('data-error');
      }

      function selectionDisplay(variant, sel) {
        if (variant && variant.title && variant.title !== 'Default Title') return variant.title;
        return Object.values(sel).join(' · ');
      }

      function updateSummary() {
        if (!picker) return;
        const sel = getSelectedOptions();
        const selectedCount = Object.keys(sel).length;
        updateChoiceAvailability(sel);

        if (selectedCount < totalOptionGroups) {
          summaryCard.setAttribute('data-state', 'empty');
          summaryText.textContent = summaryEmptyText || 'Pick your options to see your plan';
          summaryPriceEl.textContent = '';
          state.variantId = null;
          state.sellingPlanId = null;
          state.optionTitle = null;
          if (checkoutBtn) checkoutBtn.disabled = true;
          return;
        }

        const variant = variants.find(v => variantMatches(v, sel));

        if (!variant || variant.available === false) {
          summaryCard.setAttribute('data-state', 'unavailable');
          summaryText.textContent = summaryUnavailableText;
          summaryPriceEl.textContent = '';
          state.variantId = null;
          state.sellingPlanId = null;
          state.optionTitle = null;
          if (checkoutBtn) checkoutBtn.disabled = true;
          return;
        }

        let priceCents = variant.price;
        let sellingPlanId = null;
        const allocs = variant.selling_plan_allocations || [];
        if (allocs.length > 0) {
          priceCents = allocs[0].price;
          sellingPlanId = allocs[0].selling_plan_id;
        }

        if (variant.requires_selling_plan && !sellingPlanId) {
          summaryCard.setAttribute('data-state', 'unavailable');
          summaryText.textContent = 'This option needs a subscription plan but none is configured.';
          summaryPriceEl.textContent = '';
          state.variantId = null;
          state.sellingPlanId = null;
          state.optionTitle = null;
          if (checkoutBtn) checkoutBtn.disabled = true;
          return;
        }

        summaryCard.setAttribute('data-state', 'ready');
        summaryText.textContent = selectionDisplay(variant, sel);
        summaryPriceEl.textContent = formatMoney(priceCents);

        state.variantId = variant.id;
        state.sellingPlanId = sellingPlanId;
        state.optionTitle = selectionDisplay(variant, sel);
        refreshCheckoutEnabled();
        if (globalError) globalError.removeAttribute('data-show');
      }

      if (picker) {
        choiceInputs.forEach(input => {
          input.addEventListener('change', updateSummary);
        });
        updateChoiceAvailability({});
      }

      if (consentInput) {
        consentInput.addEventListener('change', function () {
          if (consentInput.checked) clearConsentError();
          refreshCheckoutEnabled();
        });
      }

      if (backBtn) backBtn.addEventListener('click', () => goTo(1));

      if (checkoutBtn) {
        checkoutBtn.addEventListener('click', async function () {
          if (!state.variantId) return;

          if (consentInput && !consentInput.checked) {
            if (consentError) consentError.textContent = consentErrorMsg;
            if (consentWrap) consentWrap.setAttribute('data-error', 'true');
            try { consentInput.focus(); } catch (_) {}
            return;
          }

          if (globalError) globalError.removeAttribute('data-show');
          checkoutBtn.disabled = true;
          const labelEl = checkoutBtn.querySelector('.sf-btn-label');
          if (labelEl) labelEl.textContent = 'Working…';

          const properties = {
            '_Name': state.name,
            '_Email': state.email,
            '_Phone': state.phone,
            '_Age': state.age,
            '_Country': state.country
          };
          if (state.optionTitle) properties['_Plan'] = state.optionTitle;
          if (consentInput && consentInput.checked) {
            properties['_Consent'] = 'Yes';
            if (consentStatement) properties['_Consent statement'] = consentStatement;
            properties['_Consent date'] = new Date().toISOString();
          }

          const payload = {
            items: [{
              id: Number(state.variantId),
              quantity: 1,
              properties: properties
            }]
          };
          if (state.sellingPlanId) payload.items[0].selling_plan = Number(state.sellingPlanId);

          try {
            goTo(3);

            const addRes = await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify(payload)
            });
            if (!addRes.ok) {
              const errBody = await addRes.json().catch(() => ({}));
              throw new Error(errBody.description || 'Could not add the subscription to your cart.');
            }

            await fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({
                attributes: {
                  'Lead Name': state.name,
                  'Lead Email': state.email,
                  'Lead Phone': state.phone,
                  'Lead Age': state.age,
                  'Lead Country': state.country
                }
              })
            }).catch(() => {});

            const checkoutUrl = '/checkout?checkout%5Bemail%5D=' + encodeURIComponent(state.email);
            window.location.href = checkoutUrl;
          } catch (err) {
            goTo(2);
            if (globalError) {
              globalError.textContent = err.message || 'Something went wrong. Please try again.';
              globalError.setAttribute('data-show', 'true');
            }
            checkoutBtn.disabled = false;
            if (labelEl) labelEl.textContent = defaultCtaLabel;
          }
        });
      }
    }

    document.addEventListener('shopify:section:load', function (e) {
      initSection(e.detail.sectionId);
    });

    document.addEventListener('shopify:section:unload', function (e) {
      const root = document.querySelector('[data-section-id="' + e.detail.sectionId + '"]');
      if (root) delete root.dataset.sfBound;
    });

    document.querySelectorAll('.sf-section[data-section-id]').forEach(el => {
      initSection(el.dataset.sectionId);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
